<template>
    <div class="recommendVOProducts">
        <img class="title" src="../../../assets/img/pullNew/courseTitle.png" alt="">
        <div v-for="(item, keys) in recommendList" :key="keys">
            <CombinationCard v-if="item.setType === 1" :item="item" @click.native="goback()" />
            <HotCourseCard v-else :key="keys" :item="item" @click.native="goback()" /></div
        >
    </div>
</template>
<script>
import { reqliveRecommended } from '@/api/live/index';
import { reqCombinationlist } from '@/api/combination';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';

export default {
  data() {
    return {
      recommendList: [],
    };
  },
  props: {
    recommendVOProduct: {
      type: Array,
    },
  },
  components: {
    CombinationCard,
    HotCourseCard,
  },
  methods: {
    // 获取推荐课程详情
    async getInfo() {
      const allProductIds = [];
      const allPackageIds = [];
      this.recommendVOProduct.forEach((child) => {
        if (child.type === 3) {
          allProductIds.push(child.productId);
        } else if (child.type === 4) {
          allPackageIds.push(child.packageId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = allProductIds.length ? await reqliveRecommended(allProductIds) : {};
      const res1 = allPackageIds.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      const resCourse = this.resetCourse(res.data || []);
      const resPackage = this.resetCoursePackage(res1.data || []);
      const allCourse = [];
      this.recommendVOProduct.forEach((child) => {
        const findRes = [...resCourse, ...resPackage].find((course) => {
          if (child.type === 3) {
            return course.productId === child.productId;
          }
          return course.packageId === child.packageId;
        });
        // eslint-disable-next-line no-unused-expressions
        findRes && allCourse.push(findRes);
      });
      this.recommendList = allCourse;
    },
    // 课程卡片
    resetCourse(recommendList) {
      recommendList.forEach((item) => {
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return recommendList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount
          && item.sellPrice > 0
          && !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    goback() {
      sessionStorage.setItem('back', true);
    },
  },
  created() {
    this.getInfo();
  },
};
</script>
<style scoped lang="scss">
.recommendVOProducts {
    width: 686px;
    margin: 48px auto;
    background: linear-gradient(180deg, #FDE8E6 0%, #FFDCDB 100%);
    border-radius: 40px;
    padding: 0 24px 20px;
    .title {
        width: 474px;
        height: 102px;
        display: block;
        margin: 0 auto 48px;
    }
}
</style>
